import React from 'react';
import { Button } from 'semantic-ui-react';

const QuantitySelector = ({ quantity, onQuantityChange, checkoutDisabled }) => {
  return (
    <Button.Group inverted>
      <Button
        disabled={quantity === 1 || checkoutDisabled}
        onClick={() => onQuantityChange(-1)}
        icon={{ name: 'minus', color: 'black' }}
      />
      <Button disabled={checkoutDisabled}>{quantity}</Button>
      <Button
        disabled={checkoutDisabled}
        onClick={() => onQuantityChange(1)}
        icon={{ name: 'plus', color: 'black' }}
      />
    </Button.Group>
  );
};

export default QuantitySelector;
